export default (props, e) => {
	let linkInnerText = e.target.innerText;
	if(linkInnerText !== '') {
		dataLayer.push({
			'event': 'cta_click',
			'cta_click': {
				'url': window.location.href,
				'text': linkInnerText
			},
			_clear: true,
		});
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/handleGtmLayerPushCTAClick.js